import { Box } from '@mui/material';
// import ChipInput from 'material-ui-chip-input';
import ClearIcon from '@mui/icons-material/Clear';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import { useState } from 'react';
import { DialogWrapper } from '../../../shared/components/common/dialogWrapper';
import ButtonWrapper from '../../../shared/formUtilities/useButton';
import { SMSNotificationService } from '../smsNotificationService';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Toaster } from '../../../shared/components/common/toaster';

export const SMSSendDialog = ({ state, notificationDetail, onClose }) => {
  const smsNotificationService = new SMSNotificationService();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const onSend = () => {
    if (!file) {
      Toaster({ msg: "Please upload the file" });
      return;
    }
    setLoading(true);
    smsNotificationService.sendSMSNotification(file, notificationDetail?.id).then(resp => {
      onClose(true);
      setLoading(false);
    }).catch(resp => {
      setLoading(false);
    });
  };

  return (
    <DialogWrapper
      loading={loading}
      maxWidth="sm"
      state={state}
      onClose={() => {
        onClose(false);
      }}
      title={'Send SMS'}
      content={
        <Box className='flex justify-between items-center'>
          <Box className='!text-[14px]'>{file ? file?.name : 'Please upload a file'}</Box>
          {!file ? <ButtonWrapper variant={'outlined'} fileUploadTypes='.xlsx, .xls' label={'Upload File'} disabled={loading} uploadButton onFileUpload={(e) => {
            setFile(e);
          }} /> : <ButtonWrapper onClick={() => { setFile(null); }} iconButton icon={<DeleteOutlineIcon color='error' />} />}
        </Box>
      }
      actions={
        <Box className="flex flex-0 justify-center">
          <ButtonWrapper
            icon={<ClearIcon></ClearIcon>}
            variant={'outlined'}
            label="Cancel"
            disabled={loading}
            onClick={() => {
              onClose(false);
            }}></ButtonWrapper>
          <ButtonWrapper
            icon={<SendToMobileIcon></SendToMobileIcon>}
            classList="!ml-3"
            type="button"
            loading={loading}
            disabled={!file}
            onClick={() => {
              onSend();
            }}
            label="Send"></ButtonWrapper>
        </Box>
      }></DialogWrapper>
  );
};
